export const environment = {
    version: '1.0.0',
    tenantId: '',
    production: true,
    urlApi: 'https://portal-bff-stg.silgov.io',
    urlAuth: 'https://auth-stg.silgov.io',
    urlParticipant: 'https://app-stg.silgov.com.br',
    // Cadastro de cidadão (visitante, spec 048 do app-frontend): o BFF também tem a própria flag.
    visitorSignupEnabled: true
}
